import React from 'react';
import StyledBox from 'views/common/components/UI/DotsLoading/DotsLoading.styles';

const DotsLoading = () => <StyledBox className="dot-flashing" />;

export { DotsLoading };
